package com.havn.app.features.reports.domain

interface SellerReportRepository {
    suspend fun reportsForAgent(agentId: String): Result<List<SellerReport>>
    suspend fun previewForReport(
        agentId: String,
        reportId: String
    ): Result<SellerReportPreview>

    suspend fun buildPreview(
        agentId: String,
        openHouseId: String,
        agentNotes: String
    ): Result<SellerReportPreview>

    suspend fun saveReport(
        agentId: String,
        draft: SellerReportDraft
    ): Result<SellerReport>

    suspend fun updateReport(
        agentId: String,
        reportId: String,
        status: SellerReportStatus,
        summary: String,
        sellerFeedback: String? = null,
        nextSteps: String? = null
    ): Result<SellerReport>

    suspend fun deleteReport(
        agentId: String,
        reportId: String
    ): Result<Unit>

    suspend fun createPropertyPerformanceDraft(
        agentId: String,
        propertyId: String,
        agentNotes: String = ""
    ): Result<SellerReportPreview>
}
